jQuery(document).ready(function($) {

	//=== MOBILE MENU ===//
	// Nav Toggle
	var $navToggle = $( '#nav-toggle' ),
	$menuWrap = $('.menu-wrap');
	
	$navToggle.on('click', function() {
		$( '#nav-toggle #menu-bars' ).toggleClass( 'button-open' );
		$menuWrap.toggleClass('menu-show');
	});
	
	// Sub-Menu Arrow expand
	$( '#navigation-mobile .menu-item-has-children > a' ).after( '<i class="fas fa-angle-down sidebar-menu-arrow"></i>' );
	$( '#navigation-mobile .sub-menu' ).hide();
	var $sidebarArrow = $('.sidebar-menu-arrow');
	
	$sidebarArrow.click(function() {
	    $(this).next().slideToggle(300);
	});
	//=== MOBILE MENU ===//
	
	
	//=== DESKTOP MENU ===//
	$( '#navigation-desktop .menu li.menu-item-has-children' ).hover(function () {
		//$(this).children("ul").stop().delay(200).animate({height: "toggle", opacity: "toggle"}, 200);
		$(this).toggleClass('open-sub');
	});
	//=== DESKTOP MENU ===//
  
});